<script setup lang="ts">
import chatWindow from '@/ai/components/ChatWindow.vue';
</script>

<template>
  <chat-window />
</template>
